import React, { memo } from "react"
import { useSelector } from "react-redux"
import { Routes, Route, Navigate } from "react-router-dom"
import { ReportReady, AdminDashBoard } from "@/components/admin-main"
import { urlPath } from "@/utils"

const SuperAdmin = memo(() => {
    const userData = useSelector((state) => state.userReducer)
    const { user } = userData
    return (
        <Routes>
            <Route path="/report-ready" element={<ReportReady />} />
            <Route path="/" element={<AdminDashBoard user={user} />} />
            <Route path="/*" element={<Navigate replace to={urlPath("super-admin-main", user.userId)} />} />
        </Routes>
    )
})

export default SuperAdmin
